import { Text } from '~components/Typography';

import { Section } from './styles';

type Props = {
	title?: string;
	text: string;
};

export const ProfileCardParagraph = ({ title, text }: Props) => {
	return (
		<Section>
			{title && (
				<Text size="M" as="h5" align="left">
					{title}
				</Text>
			)}
			<Text size="M" color="semi-transparent" align="left">
				{text}
			</Text>
		</Section>
	);
};
